import React, { useState } from "react";
import styles from "./LoginForm.module.css"; // CSS 모듈 임포트

function LoginForm({ onSubmit, error }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault(); // 폼 기본 제출 동작 방지
    onSubmit(email, password);
  };

  return (
    <div className={styles.container}>
      <h2>관리자 로그인</h2>
      <form onSubmit={handleSubmit} className={styles.form}>
        <input
          type="text"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="이메일"
          required
          className={styles.input}
        />
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="비밀번호"
          required
          className={styles.input}
        />
        {error && <p className={styles.error}>{error}</p>}
        <button type="submit" className={styles.button}>
          로그인
        </button>
      </form>
    </div>
  );
}

export default LoginForm;
